import { FC } from "react"
import { Navigate, NavigateProps, Route } from "react-router-dom"

export const createIndexRoute: FC<NavigateProps> = ({ to, ...props }) => {
  return to && <Route index element={<Navigate to={to} {...props} />} />
}
